// import LanguageDetector from "i18next-browser-languagedetector";
import i18n from "i18next";
import zhCnTrans from "../../locales/zh_CN.json";
import enGbTrans from "../../locales/en_GB.json";
import esESTrans from "../../locales/es_ES.json";
import frFRTrans from "../../locales/fr_FR.json";
import ptPTTrans from "../../locales/pt_PT.json";
import zhTWTrans from "../../locales/zh_TW.json";
import id_ID from '../../locales/id_ID.json';
import de_DE from '../../locales/de_DE.json';
import it_IT from '../../locales/it_IT.json';
import pl_PL from '../../locales/pl_PL.json';
import ru_RU from '../../locales/ru_RU.json';
import vi_VN from '../../locales/vi_VN.json';
import th_TH from '../../locales/th_TH.json';
import ar_SA from '../../locales/ar_SA.json';
import ja_JP from '../../locales/ja_JP.json';
import ko_KR from '../../locales/ko_KR.json';
import my_MM from '../../locales/my_MM.json';
import km_KH from '../../locales/km_KH.json';

import { initReactI18next } from "react-i18next";
import {langDefault} from '../../utils/language';


i18n
  // .use(LanguageDetector) //嗅探当前浏览器语言
  .use(initReactI18next) //init i18next
  .init({
    //引入资源文件
    resources: {
      zh_CN: {translation: zhCnTrans,},
      en_GB: {translation: enGbTrans,},
      es_ES: {translation: esESTrans,},
      fr_FR: {translation: frFRTrans,},
      pt_PT: {translation: ptPTTrans,},
      zh_TW: {translation: zhTWTrans,},
      id_ID: {translation: id_ID,},
      de_DE: {translation: de_DE,},
      it_IT: {translation: it_IT,},
      pl_PL: {translation: pl_PL,},
      ru_RU: {translation: ru_RU,},
      vi_VN: {translation: vi_VN,},
      th_TH: {translation: th_TH,},
      ar_SA: {translation: ar_SA,},
      ja_JP: {translation: ja_JP,},
      ko_KR: {translation: ko_KR,},
      my_MM: {translation: my_MM,},
      km_KH: {translation: km_KH,},
    },
    lng: langDefault,
    fallbackLng: "en_GB",
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
